import React, { useState, useEffect } from 'react'
import { AppBar, Box, createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import { backArrow } from './assets';

interface Props {
    backButton: (name?: string) => void;
    dropdownButton?: () => void;
    icon?: any;
    name: string;
    children?: React.ReactNode;
}

function NavigationMenuMobile({backButton, dropdownButton, icon, name}: Props){
  const classes = useStyles();
  const [flag, setFlag] = useState(false);
  const [isCompact, setIsCompact] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Only apply on mobile devices
      if (window.innerWidth <= 950) {
        // Shrink header when scrolling down, expand when scrolling up
        if (currentScrollY > lastScrollY && currentScrollY > 50) {
          // Scrolling down and past 50px - shrink to compact
          setIsCompact(true);
        } else if (currentScrollY < lastScrollY) {
          // Scrolling up - expand to original size
          setIsCompact(false);
        }
      } else {
        // Always expanded on desktop
        setIsCompact(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

    return (
        <AppBar className={`${classes.appbar} ${isCompact ? classes.compact : ''}`}>
          <Box className={`${classes.appbarBox} ${isCompact ? classes.appbarBoxCompact : ''}`} data-test-id="backbutton">
            <img src={backArrow} alt="" className={`${classes.icon} ${isCompact ? classes.iconCompact : ''}`} onClick={() => {backButton(name)}}/>
            <img src={icon} alt="" className={`${classes.icon} ${isCompact ? classes.iconCompact : ''}`}/>
            <Typography className={`${classes.name} ${isCompact ? classes.nameCompact : ''}`}>{name}</Typography>
            {
              window.location.href.includes("/messages") 
              && dropdownButton 
              && <img src={backArrow} alt="" 
              className={`${classes.dropdownIcon} ${isCompact ? classes.iconCompact : ''}`} 
              style={flag ? {transform: "rotate(-90deg)"}: {}} 
              onClick={() => {dropdownButton(); setFlag(!flag)}}/>
            }
          </Box>
        </AppBar>
    );
}

export default NavigationMenuMobile;


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      appbar: {
        backgroundColor: theme.palette.background.paper,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.drawer + 1,
        overflowX: "auto",
        transition: "all 0.3s ease-in-out", // Smooth animation for all properties
      },
      compact: {
        // Compact state - header is smaller
      },
      
      appbarBox: {
        display: "flex",
        gap: '12px',
        background: "#FFC629",
        padding: "12px",
        alignItems: "center",
        minHeight: "56px",
        transition: "all 0.3s ease-in-out", // Smooth transition
      },
      appbarBoxCompact: {
        padding: "6px 12px",
        minHeight: "40px",
        gap: '8px',
      },
      icon: {
        width: "24px",
        height: "24px",
        transition: "all 0.3s ease-in-out",
      },
      iconCompact: {
        width: "20px",
        height: "20px",
      },
      name: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#0F172A",
        transition: "all 0.3s ease-in-out",
      },
      nameCompact: {
        fontSize: "14px",
      },
      dropdownIcon:{
        width: "24px",
        height: "24px",
        alignSelf: "flex-end",
        marginLeft: "auto",
        transform: "rotate(90deg)",
        transition: "all 0.3s ease-in-out",
      }
    })
);